/* 
-----------------------------------------------------------------------------
| DATE PAGE
-----------------------------------------------------------------------------
- description: no booking data logic goes here, just metrics.
*/
import { FC } from "react";
import { DateSelection } from "../components/DateSelection";
import { _ } from "../utils/helpers";

export const DateSelectionPage: FC = () => {
   return (
      <main
         id="date-selection-page"
         className={`page-container`}
         role="application"
         aria-label={_('0ar_tosta__')}
      >
         <DateSelection />
      </main>
   )
}